import request from '@/utils/request'

// 新增三同企业申报
export function addStqysb(data) {
  return request({
    url: '/web/zlts/stqysb',
    method: 'post',
    data: data
  })
}